/**
 * Tenant Regulatory Library Page
 * Wrapper that uses the unified library component in tenant mode.
 */
import React from 'react';
import RegulatoryLibraryUnified from './RegulatoryLibraryUnified';

const TenantLibraryPage = () => {
  return <RegulatoryLibraryUnified mode="tenant" />;
};

export default TenantLibraryPage;
